module.exports = __webpack_public_path__ + "static/media/lorem-ipsum-generator-dark.7a6dae4a.png";